import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
// import { set } from "mongoose";

// Create the context
const CommonDataContext = createContext();

// Create a provider component
export const CommonDataProvider = ({ children }) => {
  const [collegeData, setCollegeData] = useState([]);
  const [microEventData, setMicroEventData] = useState([]);
  const [userData, setUserData] = useState({});
  const [staffData, setStaffData] = useState([]);

  const fetchData = async (url) => {
    try {
      const userDetails = JSON.parse(localStorage.getItem("token"));
      const token = userDetails ? userDetails.token : null;

      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return [];
      }
      console.error(`Error fetching data from ${url}:`, error);
      return [];
    }
  };

  const fetchMultipleApis = async (urls) => {
    const promises = urls.map((url) => fetchData(url));
    return Promise.all(promises);
  };

  const [apiData, setApiData] = useState(null);
  useEffect(() => {
    // console.log("state apidata", apiData);
  }, [apiData]);

  const dataFetch = async () => {
    const fetchDataAndStore = async () => {
      console.log("enterd data fetch from Common data provider");
      const apiUrls = [
        `${process.env.REACT_APP_SERVER_BASE_URL}/api/colleges/getallNames`,
        `${process.env.REACT_APP_SERVER_BASE_URL}/api/events/getall?eventType=MICRO`,
        `${process.env.REACT_APP_SERVER_BASE_URL}/api/users/findStaffByCollege`,
      ];

      try {
        // console.log('&&&&&&&&&&&&77')
        const data = await fetchMultipleApis(apiUrls);
        const newData = {};
        apiUrls.forEach((url, index) => {
          newData[index] = data[index] ? data[index] : [];
        });
        // console.log('from common data provider',newData)
        setApiData(newData);
        console.log("data from common data provider", newData);

        setCollegeData(newData[0]);
        setMicroEventData(newData[1]);
        setStaffData(newData[2]);
        // console.log(newData[1])
        // setTotalStokist(newData[0].length);

        // localStorage.setItem('monthData',JSON.stringify(newData))
        // console.log("data from context:",newData)
      } catch (error) {
        console.error("Error fetching data from APIs:", error);
      }
    };
    const fetchUserData = async () => {
      const userDetails = JSON.parse(window.localStorage.getItem("token"));
      setUserData(userDetails);
    };
    fetchDataAndStore();
    fetchUserData();
  };
  useEffect(() => {
    dataFetch();
  }, []);

  return (
    <CommonDataContext.Provider
      value={{
        // stokistData: stokistData,
        collegeData: collegeData,
        userData: userData,
        microEventData: microEventData,
        staffData: staffData,
      }}
    >
      {children}
    </CommonDataContext.Provider>
  );
};

export const useCommonDataContext = () => {
  return useContext(CommonDataContext);
};
